var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var HotelTouristRecommendations = function () {
            function HotelTouristRecommendations(recommendations) {
                _classCallCheck(this, HotelTouristRecommendations);

                this.recommendations = recommendations || [];
                this.swiper = null;
                this.modal = window.modal;
                this.modalContentId = 'hotelTouristRecommendationsModal';
                this.modalMountId = 'hotelTouristRecommendationsModalMount';
                this.modalConfig = {
                    parentCssClass: 'hotel-tourist-recommendations-modal',
                    footer: false,
                    content: {
                        htmlDetachSelectorId: this.modalContentId
                    },
                    header: {
                        theme: 'primary',
                        title: 'Советы от других туристов'
                    },
                    type: 'full'
                };

                this.initHotelTouristRecommendationsSwiper();
                this.handlers();
            }

            _createClass(HotelTouristRecommendations, [{
                key: "renderModalContent",
                value: function renderModalContent(index) {
                    var _this = this;

                    var contentHtml = "<div class=\"hotel-tourist-recommendations-list\">";

                    this.recommendations.forEach(function (recommendation) {
                        var isActive = recommendation.id == index;
                        var author = _this.escapeHtml(recommendation.author || '');
                        var date = _this.escapeHtml(recommendation.date || '');
                        var text = recommendation.text || '';

                        contentHtml += "\n                <div class=\"hotel-tourist-recommendation-in-modal " + (isActive ? 'active' : '') + "\" id=\"recommendation-" + recommendation.id + "\">\n                    <div class=\"hotel-tourist-recommendations__author-date\">\n                        " + author + ": \u043E\u0442\u0434\u044B\u0445\u0430\u043B(\u0430) \u0432 " + date + "\n                    </div>\n                    <div class=\"hotel-tourist-recommendations__text\">\n                        " + text + "\n                    </div>\n                </div>\n            ";
                    });

                    contentHtml += "</div>";

                    var mount = document.getElementById(this.modalMountId);
                    if (!mount) {
                        mount = document.createElement('div');
                        mount.id = this.modalMountId;
                        document.body.appendChild(mount);
                    }

                    mount.innerHTML = '<div id="' + this.modalContentId + '">' + contentHtml + '</div>';

                    this.modal.open(Object.assign({}, this.modalConfig, {
                        onAfterShow: function onAfterShow() {
                            _this.scrollToRecommendation(index);
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            var mountToRemove = document.getElementById(_this.modalMountId);
                            if (mountToRemove) {
                                mountToRemove.remove();
                            }
                        }
                    }));
                }
            }, {
                key: "scrollToRecommendation",
                value: function scrollToRecommendation(index) {
                    setTimeout(function () {
                        var selectedElement = document.getElementById("recommendation-" + index);
                        if (selectedElement) {
                            selectedElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }, 100);
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    if (typeof eventDispatcher !== 'undefined') {
                        eventDispatcher.on('click', '.show-full-tourist-recommendation, .js-open-recommendations-modal', function (event, element) {
                            event.preventDefault();
                            var index = element.dataset.index;
                            _this2.renderModalContent(index || 'all');
                        });
                        return;
                    }

                    document.addEventListener('click', function (event) {
                        var element = event.target.closest('.show-full-tourist-recommendation, .js-open-recommendations-modal');
                        if (element) {
                            event.preventDefault();
                            var index = element.dataset.index;
                            _this2.renderModalContent(index || 'all');
                        }
                    });
                }
            }, {
                key: "initHotelTouristRecommendationsSwiper",
                value: function initHotelTouristRecommendationsSwiper() {
                    var swiperContainer = document.querySelector('#hotelTouristRecommendationsSwiper');
                    var slides = swiperContainer.querySelectorAll('.swiper-slide');
                    var slidesCount = slides.length;

                    var params = {
                        freeMode: false,
                        loop: false,
                        slidesPerView: slidesCount === 1 ? 1.04 : 1.2,
                        spaceBetween: 10,
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        },
                        breakpoints: {
                            500: {
                                slidesPerView: Math.min(slidesCount, 2.2)
                            },
                            650: {
                                slidesPerView: Math.min(slidesCount, 2.5)
                            },
                            800: {
                                slidesPerView: Math.min(slidesCount, 3.2)
                            }
                        }
                    };

                    this.swiper = new Swiper('#hotelTouristRecommendationsSwiper', params);
                }

                // Вспомогательный метод для экранирования HTML

            }, {
                key: "escapeHtml",
                value: function escapeHtml(text) {
                    var div = document.createElement('div');
                    div.textContent = text;
                    return div.innerHTML;
                }

                // Метод для уничтожения экземпляра

            }, {
                key: "destroy",
                value: function destroy() {
                    if (this.swiper) {
                        this.swiper.destroy(true, true);
                        this.swiper = null;
                    }

                    if (this.modal) {
                        // Закрываем модальное окно если есть такой метод
                        if (typeof this.modal.hideModal === 'function') {
                            this.modal.hideModal();
                        }
                    }
                }
            }]);

            return HotelTouristRecommendations;
        }();

        window.HotelTouristRecommendations = HotelTouristRecommendations;
    }, {}] }, {}, [1]);